import styled from 'styled-components';

export const AppOutletCont = styled.section`
  display: flex;
  flex-direction: row;
`;
